import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";

import RaindropInput from "../raindrop-input/raindrop-input.tsx";
import { fetchGraphQL } from "../../services/api-raindrop";
import { isLocalEnvironment } from "../../services/environment.js";
import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import { Size } from "../../logic/enums.ts";

import { RAINDROP_SESSION_TOKEN_KEY } from "../../services/constants.js";
import RaindropTextHeading1 from "../raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextSubtitle from "../raindrop-text-subtitle/raindrop-text-subtitle.tsx";

const RaindropCardVerifyEmail = ({
  inputEmail = "",
  localMagicLink = "#",
  title = "Confirm your email",
  isSignup = false,
}) => {
  const navigate = useNavigate();
  const [inputShortCode, setInputShortCode] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();

    fetchGraphQL(`
          mutation {
            authenticateWithMagicToken(
              shortCode: "${inputShortCode}"
              email: "${inputEmail}"
            ) {
              token
            }
          }
        `)
      .then((response) => {
        const token = response?.data?.authenticateWithMagicToken?.token;
        localStorage.setItem(RAINDROP_SESSION_TOKEN_KEY, token);
        if (isSignup) {
          navigate("/raindrop/onboarding");
          return;
        }
        navigate("/raindrop/activity");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div className="flex flex-col gap-8 w-full max-w-md">
      <RaindropCard additionalClasses="gap-8 py-4">
        <div className="flex flex-col w-full text-left items-center ">
          <RaindropTextHeading1>{title}</RaindropTextHeading1>
          <RaindropTextSubtitle>
            We've sent an email with a magic link and a code. Either click the
            magic link or enter the code
          </RaindropTextSubtitle>
        </div>

        <div className="flex flex-col w-full gap-8">
          <RaindropInput
            placeholder="Enter code"
            value={inputShortCode}
            onChange={(e) => {
              setInputShortCode(e.target.value);
            }}
            isLarge={true}
            isFluid={true}
          />
          <RaindropButton
            title="Confirm"
            size={Size.Large}
            onClick={onSubmit}
            isFluid={true}
            style={ButtonStyle.Primary}
          />

          {localMagicLink !== "#" && isLocalEnvironment() && (
            <RaindropButton
              to={localMagicLink}
              title="Open Magic Link (Local only)"
              isFluid={true}
            />
          )}
        </div>
      </RaindropCard>
    </div>
  );
};

export default RaindropCardVerifyEmail;
